export default () => ({
  entities: 'employees',
  employees: []
})



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/index/resources/data.js